import * as React from "react";
import SideNavigation from "@amzn/awsui-components-react/polaris/side-navigation";
import Header from "@amzn/awsui-components-react/polaris/header";
import Box from "@amzn/awsui-components-react/polaris/box";
import PageShell from "../../../../global/components/PageShell";
import { HashPageRouter } from "../../../utils/hashPageRouter";
import ConfigManager from "./ConfigManager";
import GetCustomer from "./GetCustomer";
import InventoryDashboard from "./InventoryDashboard";
import RecipeBuilder from "./RecipeBuilder";
import ActionManager from "./ActionManager";
import AuditLog from "./AuditLog";

// Single source of truth: page key -> content component. The key doubles as the URL hash fragment
// (#recipe-builder) and sidebar href, and PageType derives from it, so keys, routing, and rendering
// can't drift. Add a page here and the rest follows.
const PAGES = {
  "get-customer": GetCustomer,
  "recipe-builder": RecipeBuilder,
  "config-manager": ConfigManager,
  "inventory-dashboard": InventoryDashboard,
  "action-manager": ActionManager,
  "audit-log": AuditLog,
} as const;
type PageType = keyof typeof PAGES;

interface State {
  activePage: PageType;
  navOpen: boolean;
}

class CpcpV2Page extends React.Component<any, State> {
  private readonly router = new HashPageRouter<PageType>(Object.keys(PAGES) as PageType[], "get-customer");

  constructor(props: any) {
    super(props);
    this.state = { activePage: this.router.initialPage(), navOpen: true };
  }

  componentDidMount() {
    this.router.start(() => this.state.activePage, (activePage) => this.setState({ activePage }));
  }

  componentWillUnmount() {
    this.router.stop();
  }

  renderContent = () => {
    const Page = PAGES[this.state.activePage];
    return <Page />;
  };

  render() {
    return (
      <PageShell
        navigationOpen={this.state.navOpen}
        onNavigationChange={(open) => this.setState({ navOpen: open })}
        navigation={
          <SideNavigation
            header={{
              text: "CPCP V2",
              href: "#get-customer",
            }}
            activeHref={`#${this.state.activePage}`}
            onFollow={e => {
              e.preventDefault();
              const activePage = this.router.resolve(e.detail.href.replace("#", ""));
              this.setState({ activePage }, () => this.router.navigate(activePage));
            }}
            items={[
              {
                type: "section",
                text: "Operations",
                items: [
                  { type: "link", text: "Get Customer", href: "#get-customer" },
                  { type: "link", text: "Recipe Builder", href: "#recipe-builder" },
                  { type: "link", text: "Config Manager", href: "#config-manager" },
                  { type: "link", text: "Inventory Dashboard", href: "#inventory-dashboard" },
                  { type: "link", text: "Action Manager", href: "#action-manager" },
                  { type: "link", text: "Audit Log", href: "#audit-log" },
                ],
              },
            ]}
          />
        }
        content={
          <div>
            <Box padding={{ top: "l", bottom: "l" }}>
              <Header variant="h1">
                Cached Pharmacy Customer Provider V2
              </Header>
            </Box>
            {this.renderContent()}
          </div>
        }
      />
    );
  }
}

export default CpcpV2Page;
